export default __webpack_public_path__ + "static/books_magazine-4928919ee9aecd3a4fdcbc011e6aced5.png";